/**
 * src/pages/AuthManagement.tsx  （/account/security/admin）
 * 管理者専用「認証管理」: 在籍中アシスタントの認証状態・リセット / 追加認証の必須化 / 認証操作のログ。
 * 画面側の制限は案内にすぎない。実際の権限チェックは API（/api/auth/mfa/admin/*, /policy）がサーバーで行う。
 */

import { Link, Navigate } from 'react-router-dom'
import { useAuth } from '../components/AuthGuard'
import { useIsMobile } from '../hooks/useIsMobile'
import AdminSecurityPanel from '../components/mfa/AdminSecurityPanel'

export default function AuthManagement() {
  const { isAdmin } = useAuth()
  const isMobile = useIsMobile()
  if (!isAdmin) return <Navigate to="/account/security" replace />

  return (
    <div style={{ maxWidth: 560 }}>
      <div style={{ marginBottom: 20 }}>
        <Link to="/account/security" style={{ fontSize: 12, color: 'var(--ink-3)', textDecoration: 'none' }}>‹ ログイン・セキュリティ</Link>
        <h2 style={{ fontSize: isMobile ? 17 : 18, fontWeight: 700, margin: '6px 0 4px' }}>認証管理</h2>
        <div style={{ fontSize: 12, color: 'var(--ink-3)' }}>管理者アカウント</div>
      </div>
      <AdminSecurityPanel isMobile={isMobile} />
    </div>
  )
}
